

<!-- בחירת דירוג עם טקסטים מתחת לתמונות -->
<div class="flex gap-1/2 justify-content-center ">
    <div class="rating-option" *ngFor="let rating of ratingOptions"
        [class.selected]="selectedRatingValue === rating.value" (click)="selectRating(rating.value, rating.image,rating.label)">
        <img [src]="rating.image" [alt]="rating.label" width="45" height="40" [title]="rating.label" />
    </div>
</div>